// extracted by mini-css-extract-plugin
export var animationAbsolute = "_21-q";
export var animationRelative = "_21-p";
export var backdropBlur = "_21-0";
export var detailLabelCell = "_21-12";
export var detailTable = "_21-11";
export var detailValueCell = "_21-13";
export var docIconBox = "_21-1d";
export var docIconBoxMd = "_21-1f";
export var docIconBoxSm = "_21-1e";
export var docTypeRow = "_21-16";
export var docTypeRowInner = "_21-17";
export var dropdownMatchDatePicker = "_21-3";
export var evidenceCardContent = "_21-1c";
export var fileUploadSpin = "_21-j";
export var gorgiasOpenButton = "_21-15 _21-d";
export var gorgiasTicketCard = "_21-14";
export var heroModalFooterButton = "_21-18";
export var hiddenContainer = "_21-o";
export var iconPrimary = "_21-1g";
export var iconSecondary = "_21-1h";
export var iconTertiary = "_21-1i";
export var integrationCard = "_21-1";
export var integrationLogoBox = "_21-2";
export var mainColumnSticky = "_21-1b";
export var maxWidthContainer = "_21-19";
export var modalContentBody = "_21-a";
export var modalHeaderImage = "_21-5";
export var modalImageLabel = "_21-7";
export var modalImageOverlay = "_21-6";
export var modalImageSubtitle = "_21-9";
export var modalImageTitle = "_21-8";
export var modalImageWrapper = "_21-4";
export var modalStickyFooter = "_21-b";
export var removeButton = "_21-e";
export var sidebarColumn = "_21-1a";
export var spinner = "_21-i";
export var timelineLine = "_21-y";
export var timelineLineBlack = "_21-10 _21-y";
export var timelineLineGray = "_21-z _21-y";
export var timelineLineHeight = "_21-x";
export var tlDotActivate = "_21-u";
export var tlDotActivateAnim = "_21-t";
export var tlDotHide = "_21-s";
export var tlDotHideAnim = "_21-r";
export var tlLineActivate = "_21-w";
export var tlLineActivateAnim = "_21-v";
export var uploadHint = "_21-n";
export var uploadIconBox = "_21-k";
export var uploadLabel = "_21-m";
export var uploadText = "_21-l";
export var uploadZone = "_21-f";
export var uploadZoneCursorDefault = "_21-h";
export var uploadZoneCursorPointer = "_21-g";
export var uploadedFileRow = "_21-c";
export var viewButton = "_21-d";